import React from 'react';
import styled from 'styled-components';
import { Tabs, Tab } from '@material-ui/core';

export const StyledTabs = styled(props => {
  return (
    <Tabs
      {...props}
      orientation="vertical"
      variant="scrollable"
      classes={{ indicator: 'indicator' }}
      TabIndicatorProps={{
        style: {
          width: 0,
          height: 0,
          borderLeft: '7px solid transparent',
          borderRight: '7px solid transparent',
          borderBottom: '8px solid #fff',
          transform: 'translateY(120px) rotate(-90deg)',
          alignSelf: 'center',
          marginRight: '-5px',
        },
      }}
      indicatorColor="primary.main"
    />
  );
})`
  && {
    height: 100%;
    width: 55px;
    position: static;
    padding: 0px;
    .MuiTab-wrapper {
      justify-content: center;
      flex-direction: row;
      transform: rotate(-90deg);
    }
  }
`;

export const StyledTabManager = styled(Tab)`
  && {
    color: #00194d;
    height: 250px;
    background: #5493bd;
    filter: drop-shadow(0px 0px 0px rgba(0, 0, 0, 0.12));
    font-size: 15px !important;
    font-weight: 400;
    text-transform: none;
    justify-content: center;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
    margin: 0px 0px;
    width: max-content;
    &:focus {
      color: #0880bc !important;
      background-color: #fff !important;
    }
    &&.Mui-selected {
      background-color: #5493bd;
      font-weight: 450;
    }
  }
`;
export const StyledOrangeTabs = styled(Tab)`
  && {
    color: rgba(0, 25, 77, 1);
    height: 250px;
    background: rgba(216, 96, 24, 0.2);
    filter: drop-shadow(0px 0px 0px rgba(0, 0, 0, 0.12));
    font-size: 14px !important;
    font-weight: 500;
    text-transform: none;
    justify-content: center;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
    margin: 0px 0px;
    width: max-content;
    &:focus {
      color: #0880bc !important;
      background-color: rgba(216, 96, 24, 1) !important;
    }
    &&.Mui-selected {
      background: rgba(216, 96, 24, 1);
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
  }
`;
export const StyledTabLawyer = styled(Tab)`
  && {
    color: #ffffff;
    height: 250px;
    background: #825474;
    filter: drop-shadow(0px 0px 0px rgba(0, 0, 0, 0.12));
    font-size: 15px !important;
    font-weight: 400;
    text-transform: none;
    justify-content: center;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
    margin: 0px 0px;
    width: max-content;
    &:focus {
      color: #0880bc !important;
      background-color: #fff !important;
    }
    &&.Mui-selected {
      background-color: #825474;
      font-weight: 450;
    }
  }
`;
export const Container = styled.main`
  background-color: #fff;
  padding: 16px;
`;
